<template>
  <tr class="bg-white-1 sticky top-0 z-10">
    <th class="min-w-48">Variation</th>
    <template v-if="!isInvisible">
      <th class="min-w-24 text-right whitespace-nowrap">Users</th>
      <th v-if="showImpressions" class="min-w-24 text-right whitespace-nowrap">Impressions</th>
      <th class="min-w-24 text-right whitespace-nowrap">{{ interactionsTitle }}</th>
      <th v-if="shouldShowCTR" class="min-w-24 text-right whitespace-nowrap">
        {{ ctrTitle }}
      </th>
    </template>
    <th v-if="isInvisible" class="min-w-24 text-right whitespace-nowrap">Users</th>
    <th v-if="hasCustomGoal" class="min-w-28 text-right whitespace-nowrap">
      {{ customGoalHeader }}
    </th>
    <th class="min-w-28 text-right whitespace-nowrap">Conversion Rate</th>
    <th class="min-w-28 text-right whitespace-nowrap">Statistical Significance*</th>
    <th class="min-w-28 text-right whitespace-nowrap">Last Updated</th>
    <template v-if="accept2Enabled && !hasCustomGoal">
      <th class="min-w-24 text-right whitespace-nowrap">Clicks (additional)</th>
      <th class="min-w-24 text-right whitespace-nowrap">CTR (additional)</th>
      <slot name="additional-headers" />
    </template>
    <slot name="trailing-headers" />
  </tr>
</template>

<script setup>
defineProps({
  isInvisible: { type: Boolean, default: false },
  hasCustomGoal: { type: Boolean, default: false },
  accept2Enabled: { type: Boolean, default: false },
  shouldShowCTR: { type: Boolean, default: false },
  showImpressions: { type: Boolean, default: true },
  interactionsTitle: { type: String, default: "" },
  ctrTitle: { type: String, default: "" },
  customGoalHeader: { type: String, default: "Conversions" },
});
</script>
